// extracted by mini-css-extract-plugin
export default {"hidden":"SectionComplexes_hidden__BqNtm","placeHolderShimmer":"SectionComplexes_placeHolderShimmer__650Uo"};